import { render, staticRenderFns } from "./successBox.vue?vue&type=template&id=0c495ae8&scoped=true&"
import script from "./successBox.vue?vue&type=script&lang=js&"
export * from "./successBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c495ae8",
  null
  
)

export default component.exports